import { render } from "./PaymentDelivery.vue?vue&type=template&id=2228d45b&scoped=true"
import script from "./PaymentDelivery.vue?vue&type=script&lang=js"
export * from "./PaymentDelivery.vue?vue&type=script&lang=js"

import "./PaymentDelivery.vue?vue&type=style&index=0&id=2228d45b&lang=scss&scoped=true"
import "./PaymentDelivery.vue?vue&type=style&index=1&id=2228d45b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2228d45b"]])

export default __exports__